import React from "react";
import styles from "./styles.module.scss";
import IFontProps from "./types/index";

export const BodyFont = ({ className, children, ...rest }: IFontProps) => (
  <p {...rest} className={styles.body + " " + className}>
    {children}
  </p>
);

export const SubtitleFont = ({ className, children, ...rest }: IFontProps) => (
  <p {...rest} className={styles.subtitle + " " + className}>
    {children}
  </p>
);
export const PageTitleFont = ({ className, children, ...rest }: IFontProps) => (
  <p {...rest} className={styles.pageTitle + " " + className}>
    {children}
  </p>
);

export const ActionFont = ({ className, children, ...rest }: IFontProps) => (
  <p {...rest} className={styles.action + " " + className}>
    {children}
  </p>
);

export const TitleFont = ({ className, children, ...rest }: IFontProps) => (
  <p {...rest} className={styles.title + " " + className}>
    {children}
  </p>
);

export const LabelFont = ({ className, children, ...rest }: IFontProps) => (
  <p {...rest} className={styles.label + " " + className}>
    {children}
  </p>
);

export const ParagraphFont = ({ className, children, ...rest }: IFontProps) => (
  <p {...rest} className={styles.paragraph + " " + className}>
    {children}
  </p>
);

export const HeaderCapsFont = ({
  className,
  children,
  ...rest
}: IFontProps) => (
  <p {...rest} className={styles.headerCaps + " " + className}>
    {children}
  </p>
);
